var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Vehicles"},[_c('TrackerLocation',{attrs:{"license-plate":"TM37FUG","imei":"6028024308","date":_vm.current_date}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }